<template>
  <div
    class="row_edit_frame mb_row_edit_frame" :style="{
      bottom: $store.state.app.footnav_edit.bottom + 'px',
      left: $store.state.app.footnav_edit.left + 'px'
    }" 
    @mouseenter="edit_show"
    @mouseleave="edit_hidden"
    v-if="$store.state.app.footnav_edit.isShow && $store.state.myRender.common.setting.footnavOpen"
    >
    <div class="row_edit">
      <p @click="edit_row">{{$t('components_my_footnav_edit_index_2312')}}</p>
      <el-tooltip class="item" effect="light" :content="$t('view_back_top_index_105')" placement="top">
        <div class="set el-icon-view add mb_hidden" @click="hidden_row"></div>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: "my_mb_edit",
  data() {
    return {
      left: 0
    };
  },
  methods: {
    edit_show() {
      //清除关闭的定时器,放置编辑弹框被关闭
      const timer = this.$store.state.app.footnav_edit.timer;
      if (timer) {
        clearTimeout(timer);
        this.$store.state.app.footnav_edit.timer = null;
      }
    },
    edit_hidden() {
      this.$store.commit("app/Reset_footnav_edit");
    },
    edit_row() {
      const id = $('.basic_footnav').attr('data-id')
      const module = this.templet.find_obj(id)
      if (module) {
        // 打开底部服务栏弹框
        this.$store.commit('right_set/set_dialog', false)
        this.$store.commit('app/SET_module_Data', module.target)
        this.$store.commit('main_dialog/Change_main_dialog_isShow', true)
        this.$store.commit('main_dialog/Change_edit_name', 'basic_footnav')
      }
    },
    hidden_row() {
      this.$store.commit('myRender/SET_footnavOpen',false)
    }
  },
  mounted() {
    this.left = $(window).width() / 2 + 375 / 2 + 10
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/my_footnav_edit/index.vue